export enum DELETION_REASON_FIELDS {
  TEXTAREA = 'textarea',
  LOOKUP = 'lookup',
  LOOKUP_AND_TEXTAREA = 'lookup_and_text',
}
